const RDC = {
  jobTitle: "Software Engineer Intern",
  company: "Regional Development Center (RDC)",
  duration: "Aug 2021 - Nov 2021",
  description:
    "Developed new features for the Consumer and Corporate website as a Front-End Engineer under the OCBC@STEM Programme",
  jobscope: [
    "Improved the UI/UX of the Consumer and Corporate website by implementing new web features for the web application",
    "Improved scalability in the project by modularizing the existing monolith web application into micro-frontend applications",
    "Utilized Typescript, ReactJS, NodeJS and qiankun in development",
  ],
  funFact: "The interns were issued a portable PC instead of laptop for work!",
};

export default RDC;
